import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Header from '../../pages/components/header/Header';
import Sidebar from '../../pages/components/sidebar/Sidebar';
import { getUserInfo } from '../../core/state/user/asyncActions';
import { RootState } from '../../core/state/state';
import { AuthStatus } from '../../core/enums/AuthStatus';
import { isMobileScreenSize } from '../../core/utils/isMobileScreenSize';
import HeaderMobileScreen from '../../pages/components/header/header-mobile-screen/HeaderMobileScreen';
import HeaderMobileMenu from '../../pages/components/header/header-mobile-menu/HeaderMobileMenu';

import './MasterPage.scss';

const MasterPage: React.FC = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const dispatch = useDispatch();
  const { projectId } = useParams<{ projectId: string }>();
  const status = useSelector((state: RootState) => state.auth.status);
  const isMobileScreen = isMobileScreenSize();

  React.useEffect(() => {
    const fetchUserInfo = async () => {
      await dispatch(getUserInfo(Number(projectId)));
    };

    if (status === AuthStatus.Authenticated) {
      fetchUserInfo();
    }
  }, [dispatch, status, projectId]);

  return (
    <div className="master-page">
      {isMobileScreen ? (
        <>
          <HeaderMobileScreen isMenuOpen={isMobileMenuOpen} handleMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
          {isMobileMenuOpen ? <HeaderMobileMenu closeMenu={() => setIsMobileMenuOpen(false)} /> : <div>{children}</div>}
        </>
      ) : (
        <>
          <Header />
          <div className={`master-page__wrapper ${isCollapsed ? 'master-page__wrapper--collapsed' : ''}`}>
            <Sidebar isCollapsed={isCollapsed} onCollapse={() => setIsCollapsed(!isCollapsed)} />
            {children}
          </div>
        </>
      )}
    </div>
  );
};

export default MasterPage;
